import { API } from "./api";

let lastClick = 0;

// Fire-and-forget analytics. Backend increments traffic counters (visits/clicks)
// surfaced in /admin/stats. Public endpoint. We omit credentials so the backend's
// wildcard CORS (Access-Control-Allow-Origin: *) is accepted by the browser.
export const track = (type) => {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type }),
      credentials: "omit",
      mode: "cors",
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* ignore */ }
};

export const trackVisit = () => track("visit");

export const trackClick = () => {
  const now = Date.now();
  if (now - lastClick < 400) return; // light throttle to avoid floods
  lastClick = now;
  track("click");
};
